module.exports = "<div class=\"cart-subtotal\">\n  <div>Subtotal:</div>\n  <div class=\"subtotal\" [innerHtml]=\"subtotal\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/navbar/shopping-cart/cart-subtotal/cart-subtotal.component.html
// module id = ../../../../../src/app/navbar/shopping-cart/cart-subtotal/cart-subtotal.component.html
// module chunks = main